import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from '@s7ui-kit/s7ui-kit';
import dateLocales from '@s7ui-kit/portal-forms/build/dateLocales';
import format from 'date-fns/format';
import classNames from 'classnames';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
import HTMLEllipsis from 'react-lines-ellipsis/lib/html';
import pushGA from '../../../services/utils/pushGA';
import LazyLoad from 'react-lazyload';
import { CDN_PATH } from '../../../constants/variables';
import getResizeImageUrl from "../../../services/utils/getResizeImageUrl";

import styles from './card.css';

const CabinService = process.env.REACT_APP_CABIN_SERVICE;

const ResponsiveEllipsis = responsiveHOC()(HTMLEllipsis);

class Card extends Component {
    state = {
        src: this.props.item.src ? this.props.item.src: '',
        hideText: false,
        maxLines: 3,
        isTitleOnImg: true
    };

    title = React.createRef();
    info = React.createRef();

    componentDidMount() {
        const { isMedia } = this.props;

        if(!isMedia) {
            this.setCard();
        }
        this.setDescription();
    };

    componentDidUpdate(prevProps) {
        const { item, deviceWidth, isMedia } = this.props;

        if (deviceWidth !== prevProps.deviceWidth && !isMedia) {
            this.setCard();
        }

        if (item !== prevProps.item && !isMedia) {
            this.setCard();
        }
    };

    setCard = () => {
        const { deviceWidth, classes, item, offersMode } = this.props;
        let widthImg = 0;
        let heightImg = 0;

        if (deviceWidth > 1008){
            widthImg = classes.lgIsBig ? 664 : 320;
            heightImg = classes.lgIsBig ? 312 : offersMode ? 120 : 80;
        } else if (deviceWidth <= 767){
            widthImg = classes.mobile320 ? 320 : 767;
            heightImg = offersMode ? 120 : 80;
        } else {
            widthImg = 320;
            heightImg = classes.mdIsBig ? 312 : offersMode ? 120 : 80;
        }

        const src = !!item.image ? getResizeImageUrl({
            imageCabinId: item.image
        }) : getResizeImageUrl({
            imageAbsoluteUrl:`${CDN_PATH === '/' ? location.origin : CDN_PATH}${CabinService}/media/by-path/raw/images/newmainpage/default-pic-news.jpg`
        });

        this.setState({ src });
    };

    setDescription = () => {
        const { offersMode, classes, deviceWidth } = this.props;

        if ( this.description ) {
            let paddingHeight = 0;

            if(deviceWidth > 767){
                paddingHeight = offersMode ?
                    classes.lgIsBig ? 148 : 132
                    :
                    classes.lgIsBig ? 118 : 102;
            } else {
                paddingHeight = offersMode ? 106 : 86
            }
            const infoHeight = this.info.offsetHeight - paddingHeight; //padding + margin внутри this.info
            const titleHeight = this.title.offsetHeight;
            let textHeight = infoHeight - titleHeight;
            const lineHeight = deviceWidth > 767 ? 22 : 20;

            if ( titleHeight > 95 || textHeight < 0) {
                this.setState({ hideText: true });
            } else {
                this.setState({ maxLines: Math.floor(textHeight / lineHeight) });
            }

            if ( offersMode && titleHeight > 70 ) {
                this.setState({ hideText: true });
            } else {
                this.setState({ maxLines: Math.floor(textHeight / lineHeight) });
            }
        }
    };

    linkClickHandler = event => {
        event.preventDefault();
        const { item: { code }, gaName, targetNewTab, isMedia, onClick, ga } = this.props;
        onClick();

        if (!isMedia) {
            pushGA(
                `PORTAL ${gaName}`,
                'Click_GoToPortal',
                code, {
                eventValue: 0,
                eventInteraction: 0,
                eventUX: 'TYPE:card',
            });
            targetNewTab ? window.open(code, '_blank') : window.location.href = code;
        } else {
            const { eventCategory, eventAction, eventLabel } = ga;
            pushGA(
                eventCategory,
                eventAction,
                eventLabel || `type:${gaName}`,
                {
                    eventValue: 0,
                    eventInteraction: 0,
                    eventUX: 'undefined',
                }
            );

            targetNewTab ? window.open(`${process.env.REACT_APP_MEDIA}${code}`, '_blank') : window.location.href = `${process.env.REACT_APP_MEDIA}${code}`;
        }
    };

    render() {
        const { lang, item, classes, itemClass, offersMode, words, getMessage, shadowMode, deviceWidth, isMedia } = this.props;
        const { src, maxLines, hideText } = this.state;

        return (
            <a
                href={!isMedia && !!item.code ? item.code : !!item.code ? `${process.env.REACT_APP_MEDIA}${item.code}` : ''}
                onClick={this.linkClickHandler}
                className={classNames({
                    [styles.card]: true,
                    [styles.cardLgB]: classes.lgIsBig,
                    [styles.cardLgS]: !classes.lgIsBig,
                    [styles.cardMdB]: classes.mdIsBig,
                    [styles.cardMdS]: !classes.mdIsBig,
                    [styles.cardOffers]: offersMode,
                    [styles.cardLgHidden]: !!classes.lgHidden,
                    [styles.cardShadow]: shadowMode,
                    [itemClass]: true
                })}
                key={`${item.identifier}-${maxLines}`}
            >
                <LazyLoad>
                    <div
                        className={classNames({
                            [styles.cardImg]: true
                        })}
                        style={{backgroundImage: `url(${src})`}}>
                    </div>
                </LazyLoad>
                <div className={styles.cardInfo} ref={ref => this.info = ref}>
                    <div className={styles.cardInfoText}>
                        <p
                            className={classNames({
                                [styles.cardTitle]: true,
                                [styles.cardTextLimit]: isMedia,
                            })}
                            dangerouslySetInnerHTML={{ __html: item.title }}
                            ref={ref => this.title = ref}
                        />
                        {!!item.subtitle &&
                            <h3
                                className={classNames({
                                    [styles.cardText]: true,
                                    [styles.cardTextLimit]: isMedia,
                                })}
                                dangerouslySetInnerHTML={{ __html: item.subtitle }}
                            />
                        }

                        <ResponsiveEllipsis
                            unsafeHTML={item.description ? item.description : ' '}
                            maxLine={maxLines}
                            ellipsis='...'
                            trimRight
                            basedOn='words'
                            className={classNames({
                                [styles.cardText]: true,
                                [styles.hidden]: hideText
                            })}
                            ref={ref => this.description = ref}
                        />

                    </div>
                    {
                        offersMode ?
                            <a href={!isMedia && !!item.code ? item.code : !!item.code ? `${process.env.REACT_APP_MEDIA}${item.code}` : ''} className={classNames({
                                [styles.cardLink]: true,
                                [styles.cardLinkMedia]: isMedia
                            })}>
                                { !isMedia ? getMessage(words, 'com.s7.offers.card.link.more') : getMessage(words, 'com.s7.offers.card.link.read')}
                            </a>
                            :
                            <p className={styles.cardDate}>{format(item.date, 'DD MMM YYYY', {
                                locale: dateLocales[lang]
                            }).replace(/\./g, '').toUpperCase()}
                            </p>
                    }
                </div>
            </a>
        )
    }
}

const mapStateToProps = state => ({
    lang: state.App.lang,
    deviceWidth: state.App.deviceWidth
});

Card.propTypes = {
    gaName: PropTypes.string,
    gaLPName: PropTypes.string,
    item: PropTypes.object,
    classes: PropTypes.shape({ mdIsBig: PropTypes.boolean, lgIsSmall: PropTypes.bool, mobile320: PropTypes.bool, }),
    itemClass: PropTypes.string,
    offersMode: PropTypes.bool,
    shadowMode: PropTypes.bool,
    targetNewTab: PropTypes.bool,
    isMedia: PropTypes.bool,
    onClick: PropTypes.func,
    ga: PropTypes.shape({eventCategory: PropTypes.string, eventAction: PropTypes.string})
};

Card.defaultProps = {
    item: {},
    classes: {},
    itemClass: '',
    offersMode: false,
    shadowMode: false,
    targetNewTab: false,
    isMedia: false,
    onClick: () => {},
    ga: {
        eventCategory: 'portal_main_s7media_section',
        eventAction: 'goto_s7media'
    }
};

export default injectIntl(connect(mapStateToProps)(Card));